import { Component, ReactNode } from 'react'
import { createPortal } from 'react-dom'

import { IPortalProps } from './types'
import { ZINDEX_SIDEBAR_MODAL } from '@app/const/consts'

const modalRoot = document.getElementById('modal-root')
const el = document.createElement('div')

export class Portal extends Component<IPortalProps> {
  public componentDidMount(): void {
    if (modalRoot) {
      el.style.zIndex = String(ZINDEX_SIDEBAR_MODAL)
      el.style.position = 'relative'
      modalRoot.appendChild(el)
    }
  }

  public componentWillUnmount(): void {
    if (modalRoot?.firstChild) {
      modalRoot.firstChild.remove()
    }
  }

  public render(): ReactNode {
    return createPortal(this.props.children, el)
  }
}
